export default "__VITE_ASSET__CBMCpWBw__"